import { render, staticRenderFns } from "./PackageIdSelect.vue?vue&type=template&id=655e1a54"
import script from "./PackageIdSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./PackageIdSelect.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports